import {IServiceFactory} from "../../../service-factory.interface";
import {OnlineCheckInBlockerSsr} from "../online-check-in-blocker-ssr";

export default class StcrSsrType extends OnlineCheckInBlockerSsr {
    constructor(services: IServiceFactory) {
        super('STCR', services);
    }
}
